
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/monthly-10k-giveaway",
      function () {
        return require("private-next-pages/monthly-10k-giveaway.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/monthly-10k-giveaway"])
      });
    }
  